import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';
import {
  Root,
  Close,
  CopyContainer,
  Icon,
  Logo,
  SubTitleCopy,
  TitleCopy,
  TryAppButton,
} from './sharedStyles';
import { instanceOf, string } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { ButtonVariations } from '../SolvPatternLibrary/Button';
import StarRating from '../SolvPatternLibrary/StarRating';
import { colors } from '../../constants/colors';
import { analyticsTrackEvent } from '../../core/analytics';
import {
  campaignNames,
  DOWNLOAD_DRIVER_DISMISS,
  DOWNLOAD_DRIVER_IMPRESSION,
} from '../../core/analytics/events';
import { isIOS, isIosSafariOnly, isMobile, isNativeApp } from '../../core/util/device';
import {
  getNativeStoreDownloadLink,
  getSolvAppStoreLink,
  getSolvPlayStoreLink,
  downloadDriverFeatureFlagCheck,
} from './util';

// TODO: once we have an app in the google play store, change this to being different for ios/android
const DOWNLOAD_DRIVER_DISMISS_COOKIE = 'download driver dismiss cookie for ios';
const SEVEN_DAYS_IN_MILLISECONDS = 604800000;

const Rating = styled(StarRating)`
  justify-self: flex-end;
  height: 12px;
  line-height: 12px;
  font-size: 12px;
`;

export class DownloadDriverBase extends PureComponent {
  static propTypes = {
    cookies: instanceOf(Cookies),
    campaignName: string,
  };

  static defaultProps = {
    campaignName: campaignNames.DEFAULT_CAMPAIGN,
  };

  constructor(props) {
    super(props);
    this.shouldShow = this.shouldShow.bind(this);
  }

  state = { shown: true };

  componentDidMount = () => {
    if (this.shouldShow())
      analyticsTrackEvent(DOWNLOAD_DRIVER_IMPRESSION, this.trackingProperties());
  };

  setCookie = () => {
    const { cookies } = this.props;
    cookies.set(DOWNLOAD_DRIVER_DISMISS_COOKIE, 'dismissed', {
      path: '/',
      expires: new Date(+new Date() + SEVEN_DAYS_IN_MILLISECONDS),
    });
  };

  trackingProperties = () => ({
    url: typeof window !== 'undefined' && window.location,
    campaignName: this.props.campaignName,
  });

  handleClick = () => {
    const { campaignName } = this.props;
    analyticsTrackEvent(DOWNLOAD_DRIVER_IMPRESSION, this.trackingProperties());
    window.location.href = getNativeStoreDownloadLink(campaignName);
  };

  handleDismiss = () => {
    analyticsTrackEvent(DOWNLOAD_DRIVER_DISMISS, this.trackingProperties());
    this.setState({ shown: false });
  };

  shouldShow() {
    if (isNativeApp() || !downloadDriverFeatureFlagCheck() || !isMobile()) return false;

    const { cookies } = this.props;
    const driverCookie = cookies.get(DOWNLOAD_DRIVER_DISMISS_COOKIE);
    return !driverCookie;
  }

  render = () => {
    if (!this.shouldShow()) return null;

    return (
      <Collapse in={this.state.shown} timeout="auto" onExited={this.setCookie} unmountOnExit>
        <Root>
          <Close onClick={this.handleDismiss} />
          <Icon alt="solv native icon" />
          <CopyContainer>
            <div>
              <TitleCopy>Solv - Find great doctors</TitleCopy>
              <SubTitleCopy>Book same-day appointments</SubTitleCopy>
            </div>
            <Rating
              size={12}
              identifier="app-rating"
              rating={5}
              primaryColor={colors.appStoreSwagger}
              spacing="6px"
            />
          </CopyContainer>
          <TryAppButton onClick={this.handleClick} variation={ButtonVariations.pinkTertiary}>
            GET APP
          </TryAppButton>
        </Root>
      </Collapse>
    );
  };
}

export default withCookies(DownloadDriverBase);
